export default __webpack_public_path__ + "static/media/ku-logo.11dae61c.png";